<template>
  <div>
    <div class="bg-custom-blue">
      <div class="container">
        <div class="row py-2">
          <!-- Filter Jahr  -->
          <div class="col-1">
            <select v-model="selectedYear" @change="getKPIDeviations()" class="form-select form-select-sm">
              <option v-for="(n, i) in 11" :key="'actualYear' - (5 + i)" :value="((actualYear - 5) + i)">{{ (actualYear - 5) + i }}</option>
            </select>
          </div>
          <!-- Filter KPI-Set -->
          <div class="col-2">
            <select v-model="selectedKPISet" class="form-select form-select-sm">
              <option :value="null">{{ $t("views.kpi.detail.cockpitNoSet") }}</option>
              <option v-for="set in kpiSets" :key="set.id" :value="set.id">{{ cleanNodeName(set.name) }}</option>
            </select>
          </div>
          <!-- Suche nach KPI-Name  -->
          <div class="col-3 ms-auto">
            <input v-model="filterName" type="text" class="form-control form-control-sm" :placeholder='$t("general.placeholderSearch")'>
          </div>
        </div>
      </div>
    </div>

    <div class="container my-2">
      <!-- Header  -->
      <div class="row align-items-center">
        <div class="col d-flex align-items-center">
          <div class="h4">
            {{ $t("views.kpi.detail.headingCockpit") }}
          </div>
        </div>
        <!-- Switch 6 oder 12 KPIs  -->
        <div class="col-auto">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" v-model="showCount" true-value="12" false-value="6">
            <label class="form-check-label small">max 12 KPIs</label>
          </div>
        </div>
      </div>
      <!-- BITTE NICHT LÖSCHEN!!! KPI Cards #1 (Actual, Plan, Dev + Forecast)  GGF. Über Switch im Header alternativ zu #2 aktivieren
      <div class="row row-cols-6 g-3">
        <div v-for="deviation in filteredKPIDeviations.slice(0, 6)" :key="deviation.id" class="col">
          <div class="card text-center shadow-sm">
            <div class="card-header d-flex align-items-center gap-2">
              <svg v-if="deviation.status_deviation === 'H'" class="bi" width="16" height="16" fill="currentColor">
                <title>{{ $t("views.kpi.edit.rating.H") }}</title>
                <use xlink:href="@/assets/icons/icons.svg#kpi-high-values" />
              </svg>
              <svg v-else-if="deviation.status_deviation === 'L'" class="bi" width="16" height="16" fill="currentColor">
                <title>{{ $t("views.kpi.edit.rating.L") }}</title>
                <use xlink:href="@/assets/icons/icons.svg#kpi-low-values" />
              </svg>
              <svg v-else class="bi" width="16" height="16" fill="currentColor">
                <title>{{ $t("views.kpi.edit.rating.N") }}</title>
                <use xlink:href="@/assets/icons/icons.svg#kpi-neutral-values" />
              </svg>
              <span class="ms-1 fw-bold small text-centered">{{ deviation.name }} [{{ deviation.unit }}]</span>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-around text-center small">
                <div>
                  <div class="text-muted">{{ $t("views.kpi.periods.period") }} YTD</div>
                  <strong>{{ formatPeriod(deviation.period) }}</strong>
                </div>
              </div>
              <div class="d-flex justify-content-around text-center small mt-2">
                <div>
                  <div class="text-muted">{{ $t("views.kpi.edit.actual") }} YTD</div>
                  <strong>{{ deviation.actual }}</strong>
                </div>
                <div>
                  <div class="text-muted">{{ $t("views.kpi.edit.plan") }} YTD</div>
                  <strong>{{ deviation.plan }}</strong>
                </div>
                <div>
                  <div class="text-muted">{{ $t("views.kpi.detail.abbreviationDev") }}</div>
                  <strong :class="getDevColor(unFormatNumber(deviation.actual), unFormatNumber(deviation.plan), deviation.status_deviation, deviation.status_yellow)">{{ deviation.devActualPlan }}</strong>
                </div>
              </div>
              <div class="d-flex justify-content-around text-center small mt-1">
                <div>
                  <div class="text-muted">{{ $t("views.kpi.edit.forecast") }}</div>
                  <strong>{{ deviation.yearForecast }}</strong>
                </div>
                <div>
                  <div class="text-muted">{{ $t("views.kpi.edit.plan") }}</div>
                  <strong>{{ deviation.yearPlan }}</strong>
                </div>
                <div>
                  <div class="text-muted">{{ $t("views.kpi.detail.abbreviationDev") }}</div>
                  <strong :class="getDevColor(unFormatNumber(deviation.yearForecast), unFormatNumber(deviation.yearPlan), deviation.status_deviation, deviation.status_yellow)">{{ deviation.devForecastPlan }}</strong>
                </div>
              </div>
              <div class="d-flex justify-content-start gap-3 mt-3">
                <a @click="selectKPI(deviation.id)" :href="'#kpiPeriodsModal' + selectedKPI.id" class="text-decoration-none fs-08" data-bs-toggle="modal">KPI-Daten</a>
                <a :href="createLink('kpi', deviation.id)" class="text-decoration-none fs-08" target="_blank">KPI-Definition </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->
      <!-- KPI Cards #2 (Actual, Plan Dev)-->
      <div class="row row-cols-6 g-3 mt-2">
        <div v-for="deviation in filteredKPIDeviations.slice(0, showCount)" :key="deviation.id" class="col">
          <div class="card text-center shadow-sm">
            <div class="card-body p-2">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div>
                  <svg v-if="deviation.status_deviation === 'H'" class="bi" width="16" height="16" fill="currentColor">
                    <title>{{ $t("views.kpi.edit.rating.H") }}</title>
                    <use xlink:href="@/assets/icons/icons.svg#kpi-high-values" />
                  </svg>
                  <svg v-else-if="deviation.status_deviation === 'L'" class="bi" width="16" height="16" fill="currentColor">
                    <title>{{ $t("views.kpi.edit.rating.L") }}</title>
                    <use xlink:href="@/assets/icons/icons.svg#kpi-low-values" />
                  </svg>
                  <svg v-else class="bi" width="16" height="16" fill="currentColor">
                    <title>{{ $t("views.kpi.edit.rating.N") }}</title>
                    <use xlink:href="@/assets/icons/icons.svg#kpi-neutral-values" />
                  </svg>
                </div>
                <div class="flex-grow-1 text-center">
                  <span class="fw-bold small">{{ deviation.name }} [{{ deviation.unit }}]</span>
                </div>
              </div>
              <div class="d-flex justify-content-around text-center small mt-2">
                <div>
                  <div class="text-muted small">{{ $t("views.kpi.edit.actual") }} YTD {{ formatPeriod(deviation.period) }}</div>
                  <strong class="fs-2"> {{ deviation.actual }}</strong>
                </div>
              </div>
              <div class="d-flex justify-content-around text-center small mt-0">
                <div>
                  <div class="text-muted small">{{ $t("views.kpi.edit.plan") }}</div>
                  <strong>{{ deviation.plan !== null && deviation.plan !== '' ? deviation.plan : '-' }}</strong>
                </div>
                <div>
                  <div class="text-muted small">{{ $t("views.kpi.detail.abbreviationDev") }}</div>
                  <strong :class="getDevColor(unFormatNumber(deviation.actual), unFormatNumber(deviation.plan), deviation.status_deviation, deviation.status_yellow)">{{ deviation.plan ? deviation.devActualPlan : '-' }}</strong>
                </div>
              </div>
              <div class="d-flex justify-content-start gap-3 mt-3">
                <a @click="selectKPI(deviation.id)" :href="'#kpiPeriodsModal' + selectedKPI.id" class="text-decoration-none fs-08" data-bs-toggle="modal">{{ $t("views.kpi.detail.cockpitLinkData") }}</a>
                <a :href="createLink('kpi', deviation.id)" class="text-decoration-none fs-08" target="_blank">{{ $t("views.kpi.detail.cockpitLinkDef") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 4 stacked Charts nebeneinander als Card-->
      <div class="row mt-4">
        <div class="col-md-3" v-for="(chart, index) in stackedCharts.slice(0, 4)" :key="index">
          <div class="card shadow-sm">
            <div class="card-body">
              <h6 class="card-title text-center">{{ chart.title }}</h6>
              <div style="height: 180px;">
              <StackedBarChart
                :chartId="'chart-' + index"
                :chartData="chart"
              />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KPIPeriodsModal :kpi="selectedKPI"></KPIPeriodsModal>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'
import KPIPeriodsModal from '../../components/monitoring/KPIPeriodsModal.vue'
import StackedBarChart from '../../components/charts/MainCockpit.vue'

export default {
  name: 'MonitoringKPICockpit',
  data () {
    return {
      selectedYear: this.$store.state.user?.settings?.favorites?.kpiDeviationSelectedYear ? this.$store.state.user.settings.favorites.kpiDeviationSelectedYear : new Date().getFullYear(),
      selectedYTDPreview: 'actualPlan',
      selectedYearPreview: 'forecastPlan',
      filterName: '',
      selectedKPISet: null,
      showCount: 6,
      stackedCharts: [
        {
          title: this.$t('views.kpi.detail.cockpitStrategies'),
          labels: [],
          datasets: [
            { label: this.$t('views.kpi.detail.noReviews'), backgroundColor: '#D3D3D3', data: [] },
            { label: this.$t('views.kpi.detail.green'), backgroundColor: '#84BEA4', data: [] },
            { label: this.$t('views.kpi.detail.yellow'), backgroundColor: '#FFC819', data: [] },
            { label: this.$t('views.kpi.detail.red'), backgroundColor: '#DB2D3E', data: [] }
          ]
        },
        {
          title: this.$t('views.kpi.detail.cockpitObjectives'),
          labels: [],
          datasets: [
            { label: this.$t('views.kpi.detail.noReviews'), backgroundColor: '#D3D3D3', data: [] },
            { label: this.$t('views.kpi.detail.green'), backgroundColor: '#84BEA4', data: [] },
            { label: this.$t('views.kpi.detail.yellow'), backgroundColor: '#FFC819', data: [] },
            { label: this.$t('views.kpi.detail.red'), backgroundColor: '#DB2D3E', data: [] }
          ]
        },
        {
          title: this.$t('views.kpi.detail.cockpitProjects'),
          labels: [],
          datasets: [
            { label: this.$t('views.kpi.detail.noReviews'), backgroundColor: '#D3D3D3', data: [] },
            { label: this.$t('views.kpi.detail.green'), backgroundColor: '#84BEA4', data: [] },
            { label: this.$t('views.kpi.detail.yellow'), backgroundColor: '#FFC819', data: [] },
            { label: this.$t('views.kpi.detail.red'), backgroundColor: '#DB2D3E', data: [] }
          ]
        },
        {
          title: this.$t('views.kpi.detail.cockpitMeasures'),
          labels: [],
          datasets: [
            { label: this.$t('views.kpi.detail.done'), data: [], backgroundColor: '#84BEA4' },
            { label: this.$t('views.kpi.detail.open'), data: [], backgroundColor: '#DB2D3E' }
          ]
        }
      ]
    }
  },
  components: {
    KPIPeriodsModal,
    StackedBarChart
  },
  computed: {
    kpiDeviations () {
      return this.$store.state.kpiDeviations
    },
    kpiSets () {
      if (!this.$store.state.kpiSetsList) return []

      const kpiSets = this.$store.state.kpiSetsList.slice(1)
      return kpiSets
    },
    filteredKPIDeviations () {
      // 1. Wenn ein KPI-Set ausgewählt ist → NUR dessen Member anzeigen
      if (this.selectedKPISet) {
        const set = this.kpiSets.find(s => s.id === this.selectedKPISet)

        if (set && set.members) {
          const allowedKPIs = set.members.map(m => m.kpi)
          return this.kpiDeviations
            .filter(dev => allowedKPIs.includes(dev.id))
            .filter(dev => dev.name.toLowerCase().includes(this.filterName.toLowerCase()))
        }

        // Falls Set leer ist → keinen Filter setzen
        return []
      }

      // 2. Wenn KEIN KPI-Set ausgewählt ist → Namenssuche anwenden
      return this.kpiDeviations.filter(dev => {
        return dev.name.toLowerCase().includes(this.filterName.toLowerCase())
      })
    },
    selectedKPI () {
      return this.$store.state.selectedKPI
    },
    loadingStatus () {
      return this.$store.state.loadingStatus
    },
    actualYear () {
      const actualYear = new Date().getFullYear()
      return actualYear
    }
  },

  methods: {
    async getKPIDeviations () {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getKPIDeviations', this.selectedYear)
      await this.$store.dispatch('getKPISets')
      await this.$store.dispatch('favoriteObject', { isList: false, objectKey: 'kpiDeviationSelectedYear', objectValue: this.selectedYear })
      const cockpitData = await this.$store.dispatch('getCockpitData', this.selectedYear)
      this.updateStackedCharts(cockpitData)
      this.$store.commit('SET_LOADING_STATUS', false)
    },

    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    getDevColor (actual, plan, statusDeviation, statusYellow) {
      return formatUtils.getDevColor(actual, plan, statusDeviation, statusYellow)
    },
    async selectKPI (kpiId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getKPI', { mode: 'manage', id: kpiId })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    },
    cleanNodeName (name) {
      return formatUtils.cleanNodeName(name)
    },
    updateStackedCharts (cockpitData) {
      // strategies
      let years = cockpitData[0].years
      const labels = years.map(y => y.year)
      if (labels.length > 0) { labels[labels.length - 1] = labels[labels.length - 1] + '+' }
      this.stackedCharts[0] = {
        ...this.stackedCharts[0],
        labels,
        datasets: [
          { ...this.stackedCharts[0].datasets[0], data: years.map(y => y.noReviews) },
          { ...this.stackedCharts[0].datasets[1], data: years.map(y => y.green) },
          { ...this.stackedCharts[0].datasets[2], data: years.map(y => y.yellow) },
          { ...this.stackedCharts[0].datasets[3], data: years.map(y => y.red) }
        ]
      }
      // objectives
      years = cockpitData[1].years
      this.stackedCharts[1] = {
        ...this.stackedCharts[1],
        labels,
        datasets: [
          { ...this.stackedCharts[1].datasets[0], data: years.map(y => y.noReviews) },
          { ...this.stackedCharts[1].datasets[1], data: years.map(y => y.green) },
          { ...this.stackedCharts[1].datasets[2], data: years.map(y => y.yellow) },
          { ...this.stackedCharts[1].datasets[3], data: years.map(y => y.red) }
        ]
      }
      // projects
      years = cockpitData[2].years
      this.stackedCharts[2] = {
        ...this.stackedCharts[2],
        labels,
        datasets: [
          { ...this.stackedCharts[2].datasets[0], data: years.map(y => y.noReviews) },
          { ...this.stackedCharts[2].datasets[1], data: years.map(y => y.green) },
          { ...this.stackedCharts[2].datasets[2], data: years.map(y => y.yellow) },
          { ...this.stackedCharts[2].datasets[3], data: years.map(y => y.red) }
        ]
      }
      // measures
      years = cockpitData[3].years
      this.stackedCharts[3] = {
        ...this.stackedCharts[3],
        labels,
        datasets: [
          { ...this.stackedCharts[3].datasets[0], data: years.map(y => y.green) },
          { ...this.stackedCharts[3].datasets[1], data: years.map(y => y.red) }
        ]
      }
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getKPIDeviations', this.selectedYear)
    await this.$store.dispatch('getKPISets')
    await this.$store.dispatch('favoriteObject', { isList: false, objectKey: 'kpiDeviationSelectedYear', objectValue: this.selectedYear })
    const cockpitData = await this.$store.dispatch('getCockpitData', this.selectedYear)
    this.updateStackedCharts(cockpitData)
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.col-kpi-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-th {
  background-color: transparent;
  border: 0;
  font-weight: bold;
}
</style>
